import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setCurrentSelector } from '../../../../redux/actions';
import { getCurrentSelector } from '../../../../redux/selectors';
import { GroupField } from './GroupFields';
class SelectorButtons extends Component {
  render() {
    let value = this.props.currentSelector;
    let onChange = this.props.setCurrentSelector;
    let id = this.props.id ?? "selector-buttons";

    return (
      <div id={id} className="field has-addons is-fullwidth">
        <p className="control">
          <button
            id={`${id}-text-button`}
            type="button"
            className={`button is-small ${
              value === 'text' ? 'is-info is-active' : ''
            }`}
            onClick={(e) => {
              onChange('text');
            }}
          >
            <span className="icon is-small">
              <i className="fas fas fa-font"></i>
            </span>
            <span>Text</span>
          </button>
        </p>

        <p className="control">
          <button
            id={`${id}-number-button`}
            type="button"
            className={`button is-small ${
              value === 'number' ? 'is-info is-active' : ''
            }`}
            onClick={(e) => {
              onChange('number');
            }}
          >
            <span className="icon is-small">
              <i className="fas fa-hashtag"></i>
            </span>
            <span>Number</span>
          </button>
        </p>

        <p className="control">
          <button
            id={`${id}-checkbox-button`}
            type="button"
            className={`button is-small ${
              value === 'checkbox' ? 'is-info is-active' : ''
            }`}
            onClick={(e) => {
              onChange('checkbox');
            }}
          >
            <span className="icon is-small">
              <i className="fas fa-check"></i>
            </span>
            <span>Checkbox</span>
          </button>
        </p>

        <p className="control">
          <button
            id={`${id}-date-button`}
            type="button"
            className={`button is-small ${
              value === 'dateTime' ? 'is-info is-active' : ''
            }`}
            onClick={(e) => {
              onChange('dateTime');
            }}
          >
            <span className="icon is-small">
              <i className="far fa-calendar-alt"></i>
            </span>
            <span>Date</span>
          </button>
        </p>

        <p className="control">
          <button
            id={`${id}-signature-button`}
            type="button"
            className={`button is-small ${
              value === 'signature' ? 'is-info is-active' : ''
            }`}
            onClick={(e) => {
              onChange('signature');
            }}
          >
            <span className="icon is-small">
              <i className="fas fa-signature"></i>
            </span>
            <span>Signature</span>
          </button>
        </p>
        <p className="control">
          <button
            id={`${id}-image-button`}
            type="button"
            className={`button is-small ${
              value === 'image' ? 'is-info is-active' : ''
            }`}
            onClick={(e) => {
              onChange('image');
            }}
          >
            <span className="icon is-small">
              <i className="far fa-image"></i>
            </span>
            <span>Image</span>
          </button>
        </p>
        <GroupField id={id} />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  currentSelector: getCurrentSelector(state)
});

export default connect(mapStateToProps, { setCurrentSelector })(
  SelectorButtons
);
